import { optedOut } from "./analytics";

// 📈 Visite comptée pour l'entonnoir de l'admin (tour 68, B8) : POST /api/visits, une fois par onglet et par page
// (« site » à l'arrivée sur le site, « devenir_prof » sur la page « Devenir prof »). Rien n'identifie le visiteur : ni
// cookie ni identifiant, seulement « déjà comptée dans cet onglet » (sessionStorage, effacé à la fermeture de l'onglet).
// L'API ne garde qu'un nombre par page et par jour. Mesure d'audience refusée sur ce navigateur (« Ne plus être
// compté ») ou signal « Ne pas suivre » : rien n'est envoyé. Jamais bloquant pour la page.
export const PAGES = ["site", "devenir_prof"];
const keyOf = (page) => `acadeclic:visite:${page}`;

const doNotTrack = () => {
  try {
    return navigator.doNotTrack === "1" || window.doNotTrack === "1";
  } catch {
    return false;
  }
};

// Envoi par le client de l'API du site, chargé seulement au moment de l'envoi
const sendVisit = (page) => import("../puglins/Utils/models").then(({ subjectGrade }) => subjectGrade.recordVisit(page));

// → true si la visite part, false sinon (déjà comptée dans cet onglet, mesure refusée, page inconnue)
export const recordVisit = (page, { storage = typeof window !== "undefined" ? window.sessionStorage : null, send = sendVisit } = {}) => {
  if (!PAGES.includes(page) || optedOut() || doNotTrack()) return false;
  try {
    if (storage?.getItem(keyOf(page))) return false;
    storage?.setItem(keyOf(page), "1");
  } catch {
    // Stockage indisponible (navigation privée stricte) : la visite part quand même
  }
  try {
    Promise.resolve(send(page)).catch(() => {});
  } catch {
    // Envoi impossible : la page s'affiche quand même
  }
  return true;
};
